<div class="hp-notification-container pos-relative mr-lg-0">
  <a
    #triggerElement
    (click)="open(); setTrackingObj($event)"
    aria-haspopup="true"
    class="notification icon-notification-icon circle-outline"
    href="javascript:void(0);"
    id="notification-button"
  >
    <div *ngIf="feedCounterValue > 0" class="feed-counter">
      <div class="feed-counter-text">
        {{ feedCounterValue }}
        <span class="sr-only">notifications are available</span>
      </div>
    </div>
    <img
      alt="Notification"
      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    />
    <span aria-hidden="true" class="sr-only">Notification</span>
  </a>
</div>
